/* @flow */

import { connect } from 'react-redux'

import type { RootState } from '../types'

import { isAdmin } from '../stores/usersStore'
import { selectCurrentUser } from '../stores/currentUser'
import Condition from './Condition'

type StateProps = {
  shouldRender: boolean,
}

function mapStateToProps(state: RootState): StateProps {
  const currentUser = selectCurrentUser(state)
  return {
    shouldRender: currentUser != null && isAdmin(currentUser),
  }
}

export default connect(mapStateToProps)(Condition)



// WEBPACK FOOTER //
// ./src/components/IfAdmin.js